import BaseSystemTable from './BaseSystemTable.vue';
import BaseSystemTableController from '@/controller/basesystemtablecontroller';
import { i18n } from '@/localize';

const baseArchiveDataSource = () => ([
  {
    title: i18n.t('generic_datasources.active'),
    key: 0
  },
  {
    title: i18n.t('generic_datasources.archive'),
    key: 1
  },
  {
    title: i18n.t('generic_datasources.all'),
    key: 2
  }
]);

const GenerateComponent = (name, pageTitle, archive, fetchDestination = null) => {
  return {
    template: `<base-system-table
    :control-name="'${name}'"
    :controller="controller"
    :page-title="pageTitle"
    :data-source="dataSource" 
    :fetchDestination="fetchDestination"
    />`,
    components: {
      'base-system-table': BaseSystemTable
    },
    created () {
      window.document.title = this.pageTitle;
    },
    data () {
      return {
        pageTitle: pageTitle,
        controller: new BaseSystemTableController(`mvc/${name}`),
        dataSource: archive ? baseArchiveDataSource() : [],
        fetchDestination: fetchDestination
      };
    }
  };
};

export const CostCode = () => Promise.resolve(GenerateComponent('CostCode', i18n.t('admin.systemtables.costcode'), true));
export const CostCategory = () => Promise.resolve(GenerateComponent('CostCategory', i18n.t('admin.systemtables.costcategory'), true));
export const ArticleGroup = () => Promise.resolve(GenerateComponent('ArticleGroup', i18n.t('admin.systemtables.articlegroup'), false, 'productgroups'));
export const HSCode = () => Promise.resolve(GenerateComponent('HSCode', i18n.t('admin.systemtables.hscode'), false));
export const ArticleProductLine = () => Promise.resolve(GenerateComponent('ArticleProductLine', i18n.t('admin.systemtables.articleproductline'), false));
export const LocationGroup = () => Promise.resolve(GenerateComponent('LocationGroup', i18n.t('admin.systemtables.locationgroup'),true));
export const RequirementType = () => Promise.resolve(GenerateComponent('RequirementType', i18n.t('admin.systemtables.requirementtype'),true));
export const Currency = () => Promise.resolve(GenerateComponent('Currency', i18n.t('admin.systemtables.currencies'),true));
export const GeneralLedger = () => Promise.resolve(GenerateComponent('GeneralLedger', i18n.t('admin.systemtables.generalledger'),true));
